import React from 'react';
import PropTypes from 'prop-types';
import Text from '../text';
import ButtonGroup from '../button-group';
import Button from '../button';
import Modal from '../modal';
import Render from '../render';
import noop from '../utils/noop';

function SubmitDialog({
  width = 376,
  height = 220,
  offsetX = 0,
  offsetY = 0,
  minWidth = 312,
  minHeight = 220,
  captions: { title, description, discard, submit, cancel },
  onDiscard = null,
  onSubmit = null,
  onCancel = noop,
  onDialogMainAction = null,
  onDialogCancel = null,
}) {
  const onSubmitAction = () => {
    if (onDialogMainAction) onDialogMainAction();
    onSubmit();
  };

  const onDiscardAction = () => {
    if (onDialogCancel) onDialogCancel();
    onDiscard();
  };

  const onCancelAction = () => {
    if (onDialogCancel) onDialogCancel();
    onCancel();
  };

  return (
    <Modal
      overlay="visible"
      centered
      resizable={false}
      draggable={false}
      className="ws-submit-dialog"
      width={width}
      height={height}
      minWidth={minWidth}
      minHeight={minHeight}
      offsetX={offsetX}
      offsetY={offsetY}
      handleSubmit={onSubmitAction}
      handleCancel={onCancelAction}
    >
      <Text type="heading-5" className="ws-submit-dialog__title">
        {title}
      </Text>
      <div className="ws-submit-dialog__content">
        <Text theme="grey">{description}</Text>
      </div>
      <ButtonGroup className="ws-submit-dialog__buttons">
        <Button stretch="block" size="large" onClick={onSubmitAction}>
          {submit}
        </Button>
        <Render if={!!onDiscard}>
          <Button stretch="block" size="large" onClick={onDiscardAction}>
            {discard}
          </Button>
        </Render>
        <Button stretch="block" size="large" onClick={onCancelAction}>
          {cancel}
        </Button>
      </ButtonGroup>
    </Modal>
  );
}

SubmitDialog.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  minWidth: PropTypes.number,
  minHeight: PropTypes.number,
  offsetX: PropTypes.number,
  offsetY: PropTypes.number,
  captions: PropTypes.shape({
    title: PropTypes.string.isRequired,
    description: PropTypes.node.isRequired,
    discard: PropTypes.string,
    submit: PropTypes.string.isRequired,
    cancel: PropTypes.string.isRequired,
  }).isRequired,
  onDiscard: PropTypes.func,
  onSubmit: PropTypes.func,
  onCancel: PropTypes.func,
  onDialogMainAction: PropTypes.func,
  onDialogCancel: PropTypes.func,
};

export default SubmitDialog;
